"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFile = exports.getUploads = exports.updateassetsdescriptions = exports.uploadFile = exports.getMissingRequiredAssets = exports.submit = exports.parseColumnsHeader = exports.parse = exports.remove = exports.save = exports.read = exports.list = exports.create = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.create = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/create"
});
// C-097 provider
exports.list = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ,
    method: "get",
    path: "provider/list"
});
exports.read = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ,
    method: "get",
    tokens: { id: "number.required" },
    path: "provider/read"
});
exports.save = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_UPDATE,
    method: "put",
    path: "provider/save"
});
exports.remove = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_DELETE,
    method: "delete",
    tokens: { id: "number.required" },
    path: "provider/remove"
});
exports.parse = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/parse",
    formData: true
});
exports.parseColumnsHeader = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/parseColumnsHeader",
    formData: true
});
exports.submit = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/submit"
});
exports.getMissingRequiredAssets = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/missingRequiredAssets"
});
exports.uploadFile = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_CREATE,
    method: "post",
    path: "provider/uploadFile",
    formData: true
});
exports.updateassetsdescriptions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "provider/updateassetsdescriptions"
});
exports.getUploads = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ,
    method: "post",
    path: "provider/getUploads",
    tokens: { id: "number.required" }
});
exports.removeFile = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_DELETE,
    method: "post",
    path: "provider/removeFile",
    tokens: { id: "number.required" }
});



//////////////////
// WEBPACK FOOTER
// ./src/api/provider/provider-client.ts
// module id = 997
// module chunks = 0 1 2